module.exports = __webpack_public_path__ + "img/dis3.10c73ed2.png";